import { studentBookingClient } from '../client';

import { PaymentPlanServiceEndpoitns } from './constants';
import { CreatePaymentPlanDto } from './dto/CreatePaymentPlanDto';
import { PaymentOptionDto } from './dto/PaymentOptionDto';
import { PaymentPlanDto } from './dto/PaymentPlanDto';

export const createPaymentPlan = async (
    paymentPlanDetails: CreatePaymentPlanDto
): Promise<PaymentPlanDto> => {
    const { data: response } = await studentBookingClient.post(
        PaymentPlanServiceEndpoitns.PostCreatePaymentPlan,
        paymentPlanDetails
    );

    const { data } = response;
    return new PaymentPlanDto({
        weeklyPrice: data.weekly_price,
        discountApplied: data.discount_applied,
        contractLengthRatio: data.contract_length_ratio,
        paymentPlanPremiumRatio: data.payment_plan_premium_ratio,
        paymentOptions: data.payment_options.map(
            (option: {
                index: number;
                name: string;
                due_date: string;
                from_date: string;
                to_date: string;
                weeks: number;
                price: number;
            }) =>
                new PaymentOptionDto({
                    index: option.index,
                    name: option.name,
                    dueDate: option.due_date,
                    fromDate: option.from_date,
                    toDate: option.to_date,
                    weeks: option.weeks,
                    price: option.price,
                })
        ),
        promotion: data.promotion,
        subtotal: data.subtotal,
        totalRent: data.total_rent,
        genericPrice: data.generic_price,
    });
};
